// client/src/pages/Admin/ResourceManager/components/ResourceSort.tsx

import React from 'react';
import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';
import { SORT_OPTIONS } from '../constants/resource.constants';

interface ResourceSortProps {
  sortOption: string;
  sortDirection: 'asc' | 'desc';
  onSortChange: (value: string) => void;
  onToggleDirection: () => void;
}

export const ResourceSort: React.FC<ResourceSortProps> = ({
  sortOption,
  sortDirection,
  onSortChange,
  onToggleDirection
}) => {
  return (
    <div className="sort-container">
      <div className="sort-wrapper">
        <ArrowUpDown size={16} className="sort-icon" />
        <select
          className="sort-select"
          value={sortOption}
          onChange={(e) => onSortChange(e.target.value)}
          aria-label="Sort resources"
        >
          {SORT_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <button
          type="button"
          className="sort-direction-btn"
          onClick={onToggleDirection}
          aria-label={`Sort ${sortDirection === 'asc' ? 'ascending' : 'descending'}`}
          title={`Sort ${sortDirection === 'asc' ? 'ascending' : 'descending'}`}
        >
          {sortDirection === 'asc' ? (
            <ArrowUp size={14} />
          ) : (
            <ArrowDown size={14} />
          )}
        </button>
      </div>
    </div>
  );
};